module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Cloud-download-91a1029c4010f47ae033b2c04725617e.svg";